// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"7b93a272","81":"49d26b7a","386":"1d5f6764","544":"06a72652","658":"93e842aa","705":"38fb9b64","856":"1aff9fd7"}[chunkId] + ".chunk.js";
};